import { OnInit, AfterViewInit, EventEmitter, OnChanges } from '@angular/core';
import { LoginService } from '../../../login';
import { ErrorHandlerService } from '../../../services';
var SignupTwoModalPopup = /** @class */ (function () {
    function SignupTwoModalPopup(userService, errorHandlerService) {
        this.userService = userService;
        this.errorHandlerService = errorHandlerService;
        this._user = {};
        this.userAddresses = { countryTO: {} };
        this.userAddresss = [{}];
        this.userSubType = {};
        this.userEducation = {};
        this.countries = [];
        this.workExpStartDateStartMonth = "";
        this.workExpStartDateStartMonthLabel = "";
        this.fromYear = "";
        this.workExpEndDateStartMonth = "";
        this.workExpEndDateStartMonthLabel = "";
        this.toYear = "";
        this.isPresent = false;
        this.results = [];
        this.usertyperesults = [];
        this.cityresults = [];
        this.eduInstresults = [];
        this.selectedCountryId = -1;
        this.selectedStateId = -1;
        this.stateIdNameMap = {};
        //cityIdNameMap: any = {};
        this.time_zone = "";
        this.loading = false;
        // Error Handler
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "Error !!";
        this.showErrorPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.isValidationError = true;
        this.isCorporateUser = true;
        this.fromMonthCal = false;
        this.toMonthCal = false;
        this.allCountries = [];
        this.isSignUpTwoModalDialogToBeDisplayed = false;
        this.countryId = null;
        this.city = "";
        this.signUpTwoData = null;
        this.signupTwoModalPopupClosed = new EventEmitter();
        this.frommonths = [];
        this.frommonths.push({ label: 'January', value: '01' });
        this.frommonths.push({ label: 'Feburary', value: '02' });
        this.frommonths.push({ label: 'March', value: '03' });
        this.frommonths.push({ label: 'April', value: '04' });
        this.frommonths.push({ label: 'May', value: '05' });
        this.frommonths.push({ label: 'June', value: '06' });
        this.frommonths.push({ label: 'July', value: '07' });
        this.frommonths.push({ label: 'August', value: '08' });
        this.frommonths.push({ label: 'September', value: '09' });
        this.frommonths.push({ label: 'October', value: '10' });
        this.frommonths.push({ label: 'November', value: '11' });
        this.frommonths.push({ label: 'December', value: '12' });
        this.tomonths = [];
        this.tomonths.push({ label: 'January', value: '01' });
        this.tomonths.push({ label: 'Feburary', value: '02' });
        this.tomonths.push({ label: 'March', value: '03' });
        this.tomonths.push({ label: 'April', value: '04' });
        this.tomonths.push({ label: 'May', value: '05' });
        this.tomonths.push({ label: 'June', value: '06' });
        this.tomonths.push({ label: 'July', value: '07' });
        this.tomonths.push({ label: 'August', value: '08' });
        this.tomonths.push({ label: 'September', value: '09' });
        this.tomonths.push({ label: 'October', value: '10' });
        this.tomonths.push({ label: 'November', value: '11' });
        this.tomonths.push({ label: 'December', value: '12' });
    }
    SignupTwoModalPopup.prototype.ngOnChanges = function () {
        console.log('this.countryId', this.countryId);
        console.log('this.city', this.city);
        console.log('2', this.signUpTwoData);
        if (this.signUpTwoData != null) {
            if (this.signUpTwoData.userSubType == 'Academic') {
                this.isCorporateUser = false;
                this.userSubType.userSubTypeMaster = this.signUpTwoData.userProfile.userType;
                this.userEducation.userEducationSubject = this.signUpTwoData.userProfile.userEducationSubject;
                this.userEducation.userEducationDegreeCourse = this.signUpTwoData.userProfile.userEducationDegreeCourse;
                this.userEducation.userEducationEducationInstitution = this.signUpTwoData.userProfile.educationalInstitution;
            }
            if (this.signUpTwoData.userSubType == 'Professional') {
                this.isCorporateUser = true;
                this.userSubType.userSubTypeMaster = this.signUpTwoData.userWork.projectResearchTitle;
                this.userEducation.userEducationEducationInstitution = this.signUpTwoData.userWork.projectResearchExpEducationInsitution;
                this.bindMonth(this.signUpTwoData.userWork.projResearchStartDateForDisplay.split(' ')[0], 'from');
                this.fromYear = this.signUpTwoData.userWork.projResearchStartDateForDisplay.split(' ')[1];
                if (this.signUpTwoData.userWork.isPresent != 'T') {
                    this.bindMonth(this.signUpTwoData.userWork.projResearchEndDateForDisplay.split(' ')[0], 'to');
                    this.toYear = this.signUpTwoData.userWork.projResearchEndDateForDisplay.split(' ')[1];
                }
                else {
                    this.isPresent = true;
                }
            }
        }
    };
    SignupTwoModalPopup.prototype.ngOnInit = function () {
        this._user = {};
        this.userAddresses = { countryTO: {} };
        this.userAddresss = [{}];
        this.userSubType = {};
        this.userEducation = {};
        this.countries = [];
        this.workExpStartDateStartMonth = "";
        this.workExpStartDateStartMonthLabel = "";
        this.fromYear = "";
        this.workExpEndDateStartMonth = "";
        this.workExpEndDateStartMonthLabel = "";
        this.toYear = "";
        this.isPresent = false;
        this.results = [];
        this.usertyperesults = [];
        this.cityresults = [];
        this.eduInstresults = [];
        this.selectedCountryId = -1;
        this.selectedStateId = -1;
        this.stateIdNameMap = {};
        this.time_zone = "";
        this.fromMonthCal = false;
        this.toMonthCal = false;
        this.userAddresses.countryTO.countryId = null;
        this.userAddresses.countryTO.countryId = this.countryId;
        this.userAddresses.city = this.city;
        this.step2PopUpOpen();
    };
    SignupTwoModalPopup.prototype.ngOnDestroy = function () {
    };
    SignupTwoModalPopup.prototype.ngAfterViewInit = function () {
    };
    SignupTwoModalPopup.prototype.clickLi = function (month, type) {
        console.log(month);
        if (type == 'from') {
            this.workExpStartDateStartMonthLabel = month.label;
            this.workExpStartDateStartMonth = month.value;
            this.fromMonthCal = false;
        }
        if (type == 'to') {
            this.workExpEndDateStartMonthLabel = month.label;
            this.workExpEndDateStartMonth = month.value;
            this.toMonthCal = false;
        }
    };
    SignupTwoModalPopup.prototype.bindMonth = function (month, type) {
        var monthVal = this.frommonths.find(function (element) {
            return element.label == month;
        });
        if (type == 'from') {
            this.workExpStartDateStartMonthLabel = month;
            this.workExpStartDateStartMonth = monthVal.value;
        }
        if (type == 'to') {
            this.workExpEndDateStartMonthLabel = month.label;
            this.workExpEndDateStartMonth = monthVal.value;
        }
    };
    SignupTwoModalPopup.prototype.showModalDialog = function () {
        if (this.isSignUpTwoModalDialogToBeDisplayed === true) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SignupTwoModalPopup.prototype.step2PopUpOpen = function () {
        var _this = this;
        if (this.allCountries.length > 0) {
            this.countries = this.allCountries;
        }
        else {
            this.userService.country().subscribe(function (data) {
                _this.allCountries = data;
                _this.countries = data;
                _this.userAddresses.countryTO.countryId = _this.countryId;
                _this.userAddresses.city = _this.city;
            }, function (error) {
                _this.handleError(error);
            });
        }
    };
    SignupTwoModalPopup.prototype.searcheduinst = function (event) {
        this.filtereduins(event.query);
    };
    SignupTwoModalPopup.prototype.filtereduins = function (query) {
        var _this = this;
        this.userService.filterEduins(query)
            .subscribe(function (data) {
            _this.eduInstresults = data.map(function (eduInsObj) { return eduInsObj.educationalInstitutionFullName; });
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupTwoModalPopup.prototype.searchusertype = function (event) {
        this.filterusertype(event.query);
    };
    SignupTwoModalPopup.prototype.filterusertype = function (query) {
        var _this = this;
        this.userService.filterUsertype(query)
            .subscribe(function (data) {
            _this.usertyperesults = data.map(function (userTypeObj) { return userTypeObj.userSubTypeMaster; });
            var previousIsCorporateUser = _this.isCorporateUser;
            _this.checkIfUSerTypeSelectedExistsInUvsity();
            if (previousIsCorporateUser != _this.isCorporateUser) {
                // clear out the edu ins/org title/degree course and campus/location fields
                if (_this.isCorporateUser == true) {
                    _this.userEducation.userEducationEducationInstitution = null; //Edu Institution
                    _this.userEducation.userEducationSubject = null; //Subject
                    _this.userEducation.userEducationCampus = null; //Campus
                    _this.userEducation.userEducationDegreeCourse = null; //Degree Course
                    if (_this.workExpStartDateStartMonth == null || _this.workExpStartDateStartMonth == '') {
                        _this.workExpStartDateStartMonth = _this.frommonths[0].value; //Start Date
                        _this.workExpStartDateStartMonthLabel = _this.frommonths[0].label; //Start Date
                    }
                    if (_this.workExpEndDateStartMonth == null || _this.workExpEndDateStartMonth == '') {
                        _this.workExpEndDateStartMonth = _this.tomonths[0].value;
                        _this.workExpEndDateStartMonthLabel = _this.tomonths[0].label; //Start Date
                    }
                }
                else {
                    _this.userEducation.userEducationEducationInstitution = null; //Organization
                    _this.userEducation.userEducationCampus = null; //Location
                    _this.userEducation.userEducationDegreeCourse = null; // Title / Designation
                    _this.workExpStartDateStartMonth = _this.frommonths[0].value; //Start Date
                    _this.workExpStartDateStartMonthLabel = _this.frommonths[0].label; //Start Date
                    _this.fromYear = '';
                    _this.workExpEndDateStartMonth = _this.tomonths[0].value;
                    _this.workExpEndDateStartMonthLabel = _this.tomonths[0].label;
                    _this.toYear = '';
                    _this.isPresent = false;
                }
            }
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupTwoModalPopup.prototype.selectStartDate = function (startDate) {
        console.log("Printing the start datetime");
        console.log(startDate);
    };
    SignupTwoModalPopup.prototype.selectFirstElementInSearchList = function () {
        if (this.usertyperesults != null && this.usertyperesults.length) {
            if (this.usertyperesults.length > 0) {
                this.userSubType.userSubTypeMaster = this.usertyperesults[0];
            }
        }
        else {
            //this.createInfoAlert("No matching results for User type, switching to Corporate profile.");
            this.isCorporateUser = true;
        }
    };
    SignupTwoModalPopup.prototype.checkIfUSerTypeSelectedExistsInUvsity = function () {
        this.isCorporateUser = true;
        if (this.usertyperesults != null && this.usertyperesults.length) {
            if (this.usertyperesults.length > 0) {
                this.isCorporateUser = false;
            }
        }
    };
    SignupTwoModalPopup.prototype.onChange = function (countryid) {
        this.selectedCountryId = countryid;
    };
    SignupTwoModalPopup.prototype.searchstate = function (event) {
        this.filterstate(this.selectedCountryId, event.query);
    };
    SignupTwoModalPopup.prototype.filterstate = function (countryid, queryState) {
        var _this = this;
        this.userService.filterState(countryid, queryState)
            .subscribe(function (data) {
            _this.results = data.map(function (stateObj) { return stateObj.stateFullName; });
            _this.stateIdNameMap = {};
            data.forEach(function (stateObj, index) {
                this.stateIdNameMap[stateObj.stateFullName] = stateObj.stateId;
                console.log("State Name Id Map ==>" + this.stateIdNameMap);
            }, _this);
            console.log("State==>" + data);
            console.log("State Name Id Map ==>" + _this.stateIdNameMap);
            console.log("State filter results ==>" + _this.results);
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupTwoModalPopup.prototype.handleDropdownClick = function (state) {
        if (state != null && state != undefined) {
            this.selectedStateId = this.stateIdNameMap[state];
        }
    };
    SignupTwoModalPopup.prototype.searchcity = function (event, state) {
        console.log("SearchCty method called, that means completemethod of the City Autocomplete called.");
        console.log("The state passed to searchCity is ==>" + state);
        if (this.selectedStateId == -1) {
            console.log("The selected state Id is -1, will not perform filtering.");
            console.log("Returning.");
            return;
            //this.selectedStateId = this.stateIdNameMap[state];
            //console.log("The selected state Id is ==>" + this.selectedStateId);
        }
        this.filtercity(this.selectedStateId, event.query);
    };
    SignupTwoModalPopup.prototype.filtercity = function (stateId, queryCity) {
        var _this = this;
        this.userService.filterCity(stateId, queryCity)
            .subscribe(function (data) {
            _this.cityresults = data.map(function (cityObj) { return cityObj.cityFullName; });
            //this.cityIdNameMap = {};
            /*data.forEach(cityObj, index) {
              this.cityIdNameMap[cityObj.cityFullName] = cityObj.cityId;
            }*/
            console.log("City==>" + data);
            //console.log("City Name Id Map ==>" + this.cityIdNameMap);
            console.log("City filter results ==>" + _this.cityresults);
        }, function (error) {
            _this.handleError(error);
        });
    };
    SignupTwoModalPopup.prototype.register2 = function (form) {
        var _this = this;
        this.showSpinner = true;
        this._user.userSubType = this.userSubType;
        this._user.userEducation = this.userEducation;
        this.userAddresss[0] = this.userAddresses;
        this._user.userAddresses = this.userAddresss;
        console.log("Register haha2" + this.workExpStartDateStartMonth);
        console.log("Register haha2" + this.workExpEndDateStartMonth);
        this._user.workExpStartDate = this.workExpStartDateStartMonth + '/01/' + this.fromYear;
        this._user.workExpEndDate = this.workExpEndDateStartMonth + '/01/' + this.toYear;
        this._user.isPresent = this.isPresent;
        this._user.timeZone = this.time_zone;
        this.userService.secondaryData(this._user)
            .subscribe(function (data) {
            console.log(data);
            // this.updateUser();
            // this.openStep2Popup = false;
            _this.handleModalPopupClose(true);
            _this.showSpinner = false;
            form.reset();
        }, function (error) {
            _this.showSpinner = false;
            _this.handleModalPopupClose(false);
            _this.handleError(error);
        });
    };
    // focusCloseButton() {
    //   if (this.isValidationError == true) {
    //     console.log("Before seting focus on close button validation error div");
    //     document.getElementById("valDiv").style.display = "block";
    //     document.getElementById("valDiv").focus();
    //     console.log("Finished seting focus on close button validation error div");
    //   }
    // }
    SignupTwoModalPopup.prototype.handleModalPopupClose = function (type) {
        this.isSignUpTwoModalDialogToBeDisplayed = false;
        this.signupTwoModalPopupClosed.emit(type);
    };
    SignupTwoModalPopup.prototype.handleEscape = function () {
        if (this.isSignUpTwoModalDialogToBeDisplayed == true) {
            this.handleModalPopupClose(false);
        }
    };
    SignupTwoModalPopup.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>");
        console.log(error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return SignupTwoModalPopup;
}());
export { SignupTwoModalPopup };
//# sourceMappingURL=signuptwo.component.js.map